import { render, staticRenderFns } from "./FinanceCustomer.vue?vue&type=template&id=0ef48900"
import script from "./FinanceCustomer.vue?vue&type=script&lang=js"
export * from "./FinanceCustomer.vue?vue&type=script&lang=js"
import style0 from "./FinanceCustomer.vue?vue&type=style&index=0&id=0ef48900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports